import * as React from 'react';

import { ILocalization } from '@shared-ui/localization-context';

import { UitkSelect } from 'uitk-react-select';
import { UitkText } from 'uitk-react-text';

import { StaticTimeSelectOptions } from './car-pickup-dropoff-time-options';

interface TimeSelectProps {
  label: string;
  invalid?: string;
  value: string;
  formattedDate: string;
  l10n: ILocalization;
  domRef?: any;
  id?: string;
  onChange: (event: any) => void;
}

export const CarPickUpDropOffTimeSelect: React.FunctionComponent<TimeSelectProps> = React.memo(
  ({ label, id, invalid, value, formattedDate = '\u00A0', onChange, l10n, domRef = null }) => (
    <div className="multi-item-time-select">
      <div className="all-b-padding-two all-t-padding-two">
        <UitkText align="left" size={300}>
          {formattedDate}
        </UitkText>
      </div>
      <UitkSelect icon="access_time" className="uitk-cell all-cell shrink" name={id} {...{ label, value, invalid, domRef, onChange, id }}>
        <StaticTimeSelectOptions l10n={l10n} />
      </UitkSelect>
    </div>
  )
);
